module.exports = __webpack_public_path__ + "9cdd70a444f64199ce7203e2d550f19c.svg";